import { NgModule, OnDestroy } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { TamasAlunoService } from '../tamas-aluno.service';
//import { Produto, Categoria, Adicionais } from '../cardapio';
import { Router, ActivatedRoute } from '@angular/router';
//import { AlertaConfirmDialog } from '../alerta-confirm';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';


@Component({
    selector: 'app-abertura',
    templateUrl: './abertura.component.html',
    styleUrls: ['./abertura.component.css']
  })

export class AberturaComponent implements OnInit, OnDestroy {
    shouldHide: boolean = true;
    shouldHide2: boolean = false;
    shouldHide3: boolean = true;
    produtoSelecionado: any[]  = [];
    inputsearch: any = '';
    contadorAdmin: any = 0;
    arrBanners: any[] = ['slide1.jpg','slide2.jpg','slide3.jpg','slide4.jpg','slide5.jpg','slide6.jpg'];
    //arrBanners: any[] = ['slide3.jpg'];
    arrFrasesTopo: any[] = ['Consuma os melhores produtos para atingir seus objetivos','Interaja, se divirta queimando calorias e fazendo o que gosta','Acompanhe de perto sua evolução e desenvolvimento em um único app','Acompanhe de perto sua evolução e desenvolvimento em um único app','Registre suas conquistas e competições que participou','Registre suas conquistas e competições que participou'];
    urlBannerTopo: any = '';
    fraseBannerTopo: any= '';
    avoidP: boolean = true;
    constructor(private route: ActivatedRoute, public tmaService: TamasAlunoService, public router: Router, public dialog: MatDialog) {}

    ngOnInit() {
        //check dados ls, se sim redireciona pro login
        console.log("from app");
        //infoLoaded();
        console.log(this.route.snapshot.paramMap.get('token'));
        console.log(this.route.snapshot.paramMap.get('so'));
        if(this.route.snapshot.paramMap.get('token') != undefined){
            localStorage.removeItem("tmsMerge");
            //treinoFix: qDados['treinoFix'], dietaFix: qDados['dietaFix']
            localStorage["tmsMerge"] = JSON.stringify({ token: this.route.snapshot.paramMap.get('token'), so: this.route.snapshot.paramMap.get('so')  });
        }

      

        if(this.route.snapshot.paramMap.get('so') != undefined){
            this.tmaService.hcSO = this.route.snapshot.paramMap.get('so');
        }

        if(this.tmaService.logado){
            this.router.navigate(['home'], {replaceUrl: true})
        }
        else{
            
            if (localStorage.getItem("tmsDadosCliente") !== null) {
                this.router.navigate(['autenticar']);
            }
            else{
                
                this.tmaService.eventoFS(true);
                console.log("modo full");
                this.loadScript('../../assets/js/customswiper.js');
                var qRandom = Math.floor(Math.random() * this.arrBanners.length);
                this.urlBannerTopo = '../../assets/img/' + this.arrBanners[qRandom];
                this.fraseBannerTopo = this.arrFrasesTopo[qRandom];
            }
        }

        if(this.tmaService.hcWA && this.tmaService.hcSO == 'ios' || this.tmaService.hcWA && this.tmaService.hcSO == 'android'){
            this.avoidP = true;
        }
        else{
            this.avoidP = false;
        }
       
        
    }
    
    ngOnDestroy(){
        console.log("destroy");
        this.tmaService.eventoFS(false);
      }

    goInicio() :void{

        this.router.navigate(['autenticar']);
        //this.router.navigate(['inicio/']);
    }

    goCadastrar() :void{
        this.tmaService.paginaAnterior = "abertura";
        this.router.navigate(['cadastrar']);
    }

    goLogin() :void{
        this.tmaService.paginaAnterior = "abertura";
        this.router.navigate(['login']);
    }

    goPremium() :void{
        this.tmaService.paginaAnterior = "abertura";
        this.router.navigate(['premium']);
    }

    goNegocios() :void{
        //alert("Aqui vai pra tela com mais informações");
        this.router.navigate(['negocios']);
    }
    goContato() :void{
        this.router.navigate(['contato']);
    }

    goTermos() :void{
        this.router.navigate(['termos-de-uso']);
    }

    goExcluir() :void{
        this.router.navigate(['excluir-conta']);
    }
   

    public loadScript(url: string) {
        const body = <HTMLDivElement> document.body;
        const script = document.createElement('script');
        script.innerHTML = '';
        script.type = 'text/javascript';
        script.src = url;
        script.async = false;
        script.defer = true;
        body.appendChild(script);
      }

}
